import React, { useEffect, useState } from 'react'
import {
  Input,
  Button,
  Space,
  Table,
  Popconfirm,
  Result,
} from 'antd'
import { PlusOutlined, MinusOutlined, InboxOutlined } from '@ant-design/icons'
import styles from './SuccessResult.module.css'
import { clearAllCookies } from '../../../../util/handleObject'
import Cookies from 'js-cookie'
import _default from 'antd/es/affix/style'

const { TextArea } = Input
const SuccessResult = (props) => {
  useEffect(() => {}, []) // 空数组意味着这个 effect 只会在组件挂载时执行一次

  return (
    <div>
      <Result
        status="success"
        title={props.accountList.length + '条数据已成功导入!'}
        subTitle={
          <Space style={{ marginTop: 16 }}>
            <Button type="primary" onClick={() => props.closeMethod()}>
              返回列表
            </Button>
          </Space>
        }
      />
    </div>
  )
}

export default SuccessResult
